import { io } from "socket.io-client";

export const socketAnalytics = io(process.env.REACT_APP_ANALYTICS_API_URL, {
  autoConnect: false,
});